<div class="ag-form-control" #viewControl matTooltip="{{ !!hint && control.invalid && control.dirty ? hint : null }}" [class.has-errors]="control?.invalid && control?.dirty" [class.disabled]="control?.disabled">
  <div class="ag-value">
    <input [type]="inputType" [formControl]="control" placeholder=" " (focus)="onFocus()" (blur)="onBlur()" />
    <label for="value">{{ label }}</label>
  </div>
</div>
